import React from 'react';

import { Flex, Text } from '@chakra-ui/react';

export function PartnerBadge({ value, variant }) {
  return (
    <Flex flexDir="column">
      <Text
        color="gray.500"
        variant={variant}
        noOfLines={1}>
        {value?.name || 'N/A'}
      </Text>
      <Text
        variant={variant}
        color="gray.400">
        {value?.address?.code}
      </Text>
    </Flex>
  );
}
